import { forwardRef, useMemo } from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { Box, Button, Dialog, DialogActions, Slide, Typography } from '@mui/material';
import { useDialogStore } from '../../stores/dialogStore';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const GlobalDialog = () => {
  const { open, title, message, actions, variant, closeDialog } = useDialogStore();

  const variantTheme = useMemo(() => {
    switch (variant) {
      case 'error':
        return {
          color: '#ef4444',
          backgroundColor: '#fef2f2',
          icon: <CancelIcon sx={{ fontSize: '3.25rem', color: '#ef4444' }} />,
        };
      case 'warning':
        return {
          color: '#facc15',
          backgroundColor: '#fefce8',
          icon: <ErrorIcon sx={{ fontSize: '3.25rem', color: '#facc15' }} />,
        };
      case 'success':
      default:
        return {
          color: '#12ec6d',
          backgroundColor: '#d0fbe2',
          icon: <CheckCircleIcon sx={{ fontSize: '3.25rem', color: '#12ec6d' }} />,
        };
    }
  }, [variant]);

  return (
    <Dialog
      open={open}
      onClose={closeDialog}
      TransitionComponent={Transition}
      PaperProps={{
        sx: { width: '100%', maxWidth: '450px', padding: '20px' },
      }}
    >
      <Box
        sx={{
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          backgroundColor: variantTheme.backgroundColor,
          margin: '0 auto 15px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {variantTheme.icon}
      </Box>
      <Typography
        sx={{
          fontSize: '2.25rem',
          fontWeight: '700',
          color: '#171717',
          textAlign: 'center',
          lineHeight: 1,
          marginBottom: '10px',
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontSize: '1.25rem',
          lineHeight: 1,
          color: '#737373',
          marginBottom: '20px',
          textAlign: 'center',
          whiteSpace: 'pre-wrap',
        }}
      >
        {message}
      </Typography>
      <DialogActions sx={{ alignItems: 'center' }}>
        {actions ?? (
          <Button
            onClick={closeDialog}
            sx={{
              width: '100%',
              height: '40px',
              fontSize: '1.25rem',
              color: '#171717',
              backgroundColor: variantTheme.color,

              '&:hover': {
                color: '#171717',
                backgroundColor: variantTheme.color,
                opacity: '.85',
              },
            }}
          >
            Close
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default GlobalDialog;
